import {PROVINCE, PROVINCE_LOCALE} from '@/constant/province';
import {getLocalData} from '@/lib/base/localData';

/**
 * 取得 provinceId
 * @returns {Promise} provinceId
 */
const getProvinceId = () => {
  const userLocale =
    navigator.languages && navigator.languages.length
      ? navigator.languages[0]
      : navigator.language;
  const regionCode = window.location.pathname.split('/')[1];
  const id =
    Object.keys(PROVINCE).find((id) => PROVINCE[id].value === regionCode) ||
    JSON.parse(getLocalData('provinceId')) ||
    PROVINCE_LOCALE[userLocale] ||
    1;
  return Number(id);
};

export default getProvinceId;
